import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from "gatsby-plugin-intl"

import axios from 'axios';
import Cookies from 'js-cookie';

export class FormaServicios extends Component {

	constructor(props){
		super(props);


		this.state = {
			firstname: '',
			lastname: '',
			email: '',
			company: '',
			puesto: '',
			area_de_trabajo: '',
			motivo_de_contacto: '',
			solution: '',
			message: ''
		}

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleInputChange(event){

		const target = event.target;
		const value = target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});

	}

	handleSubmit(event){
		event.preventDefault();

		const body = {
			fields: [
				{
					name: 'firstname',
					value: this.state.firstname
				},
				{
					name: 'lastname',
					value: this.state.lastname
				},
				{
					name: 'email',
					value: this.state.email
				},
				{
					name: 'company',
					value: this.state.company
				},
				{
					name: 'job_position',
					value: this.state.puesto
				},
				{
					name: 'work_area',
					value: this.state.area_de_trabajo
				},
				{
					name: 'contact_reason',
					value: this.state.motivo
				},
				{
					name: 'mensaje',
					value: this.state.message
				},
				{
					name: 'solution_of_interest',
					value: this.state.solution
				}
			],
			context: {
				hutk:  Cookies.get('hubspotutk'),
				pageUri:  window.location.href,
				pageName: document.title
			}
		};

		console.log(body);

		const options = {
			headers: {'Content-Type': 'application/json'}
		  };


		// debug BOT
		/*
		axios.post(`http://localhost:53634/fapibot/v1/formdata`,  body , options)
		  .then(res => {
			console.log(res);
			console.log(res.data);

			if (typeof window !== `undefined`) window.location.replace('/gracias');
		});
		*/


		axios.post(`https://api.hsforms.com/submissions/v3/integration/submit/7700705/1109b8ba-b84f-442e-8e0d-cf2b37cc4d24`,  body , options)
		  .then(res => {
			console.log(res);
			console.log(res.data);

			if (typeof window !== `undefined`) window.location.replace('/gracias');
		});

	}

	render() {
		return (
			<form name="contacto" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col-12 col-sm-4">
						<div className="form-group">
							<label htmlFor="Nombre"><FormattedMessage id="contacto.nombre" /> <span>*</span></label>
							<input type="text" className="form-control" id="Nombre" name="firstname"  onChange={this.handleInputChange} required/>
						</div>
					</div>
					<div className="col-12 col-sm-4">
						<div className="form-group">
							<label htmlFor="Email"><FormattedMessage id="contacto.apellido" /> <span>*</span></label>
							<input type="text" className="form-control" id="LastName" name="lastname" onChange={this.handleInputChange} required/>
						</div>
					</div>
					<div className="col-12 col-sm-4">
						<div className="form-group">
							<label htmlFor="Tel"><FormattedMessage id="contacto.email" /> <span>*</span></label>
							<input type="email" className="form-control" id="email" name="email" onChange={this.handleInputChange} required/>
						</div>
					</div>
					<div className="col-6">
						<div className="form-group">
							<label htmlFor="company"><FormattedMessage id="contacto.nombreempresa" /> <span>*</span></label>
							<input type="text" className="form-control" id="company" name="company" required onChange={this.handleInputChange} />
						</div>
					</div>
					<div className="col-6">
						<div className="form-group">
							<label htmlFor="puesto"><FormattedMessage id="contacto.puesto" /> <span>*</span></label>
							<select type="text" className="form-control" id="puesto" name="puesto" onChange={this.handleInputChange} required >
								<option value="">Selecciona</option>
								<option value="Director General/Dueño/Presidente">Director General/Dueño/Presidente</option>
								<option value="Director de Área">Director de Área</option>
								<option value="Gerente/Coordinador de Área">Gerente/Coordinador de Área</option>
								<option value="Ejecutivo/Analista">Ejecutivo/Analista</option>
								<option value="Otro">Otro</option>
							</select>
						</div>
					</div>
					<div className="col-4">
						<div className="form-group">
							<label htmlFor="area_de_trabajo"><FormattedMessage id="contacto.area_de_trabajo" /> <span>*</span></label>
							<select type="text" className="form-control" id="area_de_trabajo" name="area_de_trabajo" onChange={this.handleInputChange} required >
								<option value="">Selecciona</option>
								<option value="Operaciones">Operaciones</option>
								<option value="Logística">Logística</option>
								<option value="Almacén">Almacén</option>
								<option value="Administración/Finanzas/Compras">Administración/Finanzas/Compras</option>
								<option value="Otra">Otra</option>
							</select>
						</div>
					</div>
					<div className="col-4">
						<div className="form-group">
							<label htmlFor="motivo"><FormattedMessage id="contacto.motivo" /> <span>*</span> </label>
							<select type="text" className="form-control" id="motivo" name="motivo" onChange={this.handleInputChange} required>
								<option value="">Selecciona</option>
								<option value="Me interesa una cotización de los servicios">Me interesa una cotización de los servicios</option>
								<option value="Soy cliente">Soy cliente</option>
								<option value="Soy proveedor">Soy proveedor</option>
								<option value="Otro">Otro</option>
							</select>
						</div>
					</div>
					<div className="col-4">
						<div className="form-group">
							<label htmlFor="motivo"><FormattedMessage id="contacto.solucioninteres" /> <span>*</span> </label>
							<select type="text" className="form-control" id="solution" name="solution" onChange={this.handleInputChange} required>
								<option value="">Selecciona</option>
								<option value="Maritimo">Maritimo</option>
								<option value="Terrestre">Terrestre</option>
								<option value="Aeréo">Aeréo</option>
								<option value="Agencia Aduanal">Agencia Aduanal</option>
								<option value="ILM">ILM</option>
							</select>
						</div>
					</div>
					<div className="col-12">
						<div className="form-group">
							<label htmlFor="Mensaje"><FormattedMessage id="contacto.mensaje" /></label>
							<textarea name="message" id="message" rows="5" className="form-control" onChange={this.handleInputChange}></textarea>
						</div>
					</div>
					<div className="col-12">
						<button type="submit" className="btn btn-solid rojo big text-uppercase"><FormattedMessage id="contacto.btn" /></button>
					</div>
				</div>
			</form>
		)
	}

}

export default injectIntl(FormaServicios)
